import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Marketplace from "@/pages/Marketplace";
import ItemDetail from "@/pages/ItemDetail";
import Bundles from "@/pages/Bundles";
import BundleDetail from "@/pages/BundleDetail";
import Comedy from "@/pages/Comedy";
import Premium from "@/pages/Premium";
import Login from "@/pages/Login";
import Account from "@/pages/Account";
import Submit from "@/pages/Submit";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Layout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/marketplace" element={<Layout><Marketplace /></Layout>} />
      <Route path="/item/:id" element={<Layout><ItemDetail /></Layout>} />
      <Route path="/bundles" element={<Layout><Bundles /></Layout>} />
      <Route path="/bundle/:id" element={<Layout><BundleDetail /></Layout>} />
      <Route path="/comedy" element={<Layout><Comedy /></Layout>} />
      <Route path="/premium" element={<Layout><Premium /></Layout>} />
      <Route path="/account" element={<Layout><Account /></Layout>} />
      <Route path="/submit" element={<Layout><Submit /></Layout>} />
      <Route path="/login" element={<Layout><Login /></Layout>} />
      <Route path="/admin" element={<Layout><Admin /></Layout>} />
      <Route path="/payment/success" element={<Layout><PaymentSuccess /></Layout>} />
      <Route path="/payment/cancel" element={<Layout><PaymentCancel /></Layout>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#0A0A14",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "#fff",
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
